import { $sxhr } from "../../stempcore";

export default {
  //获取登录注册的地址
  getRegistrationForm: info => {
    return $sxhr.post("member/form/GetForNewForm", info);
  },
  getCustomForm: info => {
    return $sxhr.post("api/customform/get", info);
  },
  checkRegistration: info => {
    return $sxhr.post("webinar/open/checkRegistration", info);
  },
  silentSignUp: info => {
    return $sxhr.post("api/webinar/contacts/signup", info);
  },
  logoutWeChat: info => {
    return $sxhr.post("member/member/associate/Logout", info);
  },
  //记录浏览行为
  activeRecords: info => {
    return $sxhr.post("api/webinar/live/site/browse", info);
  },
  getWxSignature: info => {
    return $sxhr.post("article/share", info);
  },
  getTokenByCode: info => {
    return $sxhr.post("api/member/verify/token/getbycode", info);
  },
  getContactByCode: info => {
    return $sxhr.post("contact/getByCode", info);
  },
  getAppId: info => {
    return $sxhr.post("weChat/getAppId", info);
  },
  getDefWeChat: info => {
    return $sxhr.post("weChat/getDef", info);
  },
  getOAuth: info => {
    return $sxhr.post("member/form/GetOAuthUrlByWeChatId", info);
  },
  getWxcode: info => {
    return $sxhr.post("public/wx_interface/wxcode", info);
  }
};
